<mat-icon *ngIf="value" class="state-true">check</mat-icon>
<mat-icon *ngIf="!value" class="state-false">close</mat-icon>
